import { reduxKey } from './constants';
export function getCurrentModal(state) {
    var stack = state[reduxKey];
    if (!stack || !stack.length) {
        return;
    }
    return stack[stack.length - 1];
}
export function getModals(state) {
    var stack = state[reduxKey];
    if (!stack) {
        return [];
    }
    return stack;
}
//# sourceMappingURL=selectors.js.map